module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/mobile-app-1-53d9843a113c173eeed0eb0b91eb533b.jpg";